<div class="checkbox-with-label-wrapper" [ngClass]="disabled ? 'disabled' : ''">
  <app-checkbox
    (checked)="onClick()"
    [disabled]="disabled"
    [isChecked]="getState()"
    [ariaLabel]="ariaLabel || label"></app-checkbox>
  <ng-container *ngIf="label">
    <span (click)="onClick()" class="checkbox-label" [style.font-weight]="fontWeight">{{ label }}</span>
  </ng-container>
</div>
